var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"campaign-targeting"},[(_vm.selecting === 'utm')?_c('utm',{attrs:{"aid":_vm.aid,"startDate":_vm.startDate,"endDate":_vm.endDate,"utmCache":_vm.utm,"otherKeySet":false},on:{"onSetUtm":function($event){return _vm.onSetUtm($event)},"onCloseLayer":_vm.onCloseLayer}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }